export default {
  partners:[]
}